import { takeLatest } from 'redux-saga/effects';
import { SIGN_OUT } from '../actions/signout';
import { cdnLogin } from '../../app/conf';
import { changeConfigChildRoute } from '../../home/actions/config';
import { setUserLogin } from '../../home/actions/loggedUser';
import { setTokens } from '../actions/token';

const signOutWorker = action => {
    changeConfigChildRoute();
    setUserLogin();
    setTokens(null, null);
    window.location.href = cdnLogin;
};

export default [
    takeLatest(SIGN_OUT, signOutWorker)
];
